export default __webpack_public_path__ + "static/media/icon-birthday.4fe435b8.svg";